import { createFileRoute } from "@tanstack/react-router"
import Users from "~/pages/users"

export const Route = createFileRoute("/_auth/internal/customer-management/_layout/users")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Users />
}
